<template>
  <svg
    width="161"
    height="174"
    viewBox="0 0 161 174"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M81 140C114.136 140 141 113.189 141 80C141 46.811 114.018 20 81 20C47.8639 20 21 46.811 21 80C21 113.189 47.8639 140 81 140Z"
      fill="url(#paint0_linear_10083_73648)"
    />
    <g filter="url(#filter0_d_10083_73648)">
      <path
        d="M115.032 43.4874C115.774 44.1362 116.251 45.036 116.37 46.0144L125.771 123.124C126.065 125.814 124.092 128.133 121.402 128.427L44.622 136.821C41.9323 137.116 39.491 135.155 39.2103 132.588L28.1424 31.3558C27.8483 28.6661 29.8218 26.347 32.5115 26.053L86.3945 20.1619C87.5071 20.0402 88.6198 20.3903 89.4623 21.1271L115.032 43.4874Z"
        fill="url(#paint1_linear_10083_73648)"
      />
    </g>
    <path
      d="M79.1858 37.6526L42.3852 41.676C41.5294 41.7696 40.7156 41.1162 40.622 40.2604C40.5284 39.4046 41.1818 38.5908 42.0376 38.4972L78.8382 34.4738C79.694 34.3802 80.5078 35.0336 80.6014 35.8894C80.6949 36.7452 80.0416 37.559 79.1858 37.6526Z"
      fill="#047CFF"
    />
    <path
      d="M57.5299 48.9283L43.3476 50.4789C42.4918 50.5725 41.678 49.9191 41.5844 49.0633C41.4908 48.2074 42.1442 47.3937 43 47.3001L57.0601 45.7629C57.9159 45.6693 58.7297 46.3227 58.8232 47.1785C58.9168 48.0344 58.2634 48.8481 57.5299 48.9283Z"
      fill="#047CFF"
    />
    <path
      opacity="0.24"
      d="M65.3507 120.458L51.1684 122.009C50.3126 122.102 49.4988 121.449 49.4052 120.593C49.3116 119.737 49.965 118.924 50.8208 118.83L64.8809 117.293C65.7367 117.199 66.5505 117.853 66.644 118.709C66.7376 119.564 66.0842 120.378 65.3507 120.458Z"
      fill="url(#paint2_linear_10083_73648)"
    />
    <path
      opacity="0.24"
      d="M88.1401 19.9709L90.5195 41.7334C90.8536 44.7899 93.8107 46.9411 96.8672 46.6069L116.184 44.4949"
      fill="url(#paint3_linear_10083_73648)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.2258 58.3651L103.415 56.2671C104.239 56.177 104.979 56.7716 105.069 57.5952L106.023 66.3222L85.343 68.5832L84.2258 58.3651ZM82.5717 57.037L45.4486 61.0957C43.8016 61.2758 42.6124 62.7569 42.7924 64.404L47.5871 108.258C47.7672 109.905 49.2483 111.095 50.8954 110.914L108.699 104.595C110.346 104.415 111.535 102.933 111.355 101.286L106.56 57.4321C106.38 55.7851 104.899 54.5959 103.252 54.776L84.0628 56.874L82.5717 57.037ZM82.7347 58.5281L83.8519 68.7463L45.2377 72.968L44.2836 64.241C44.1935 63.4174 44.7881 62.6769 45.6116 62.5868L82.7347 58.5281ZM45.4007 74.4591L46.5993 85.4224L85.2135 81.2006L84.0149 70.2374L45.4007 74.4591ZM46.7624 86.9135L47.9611 97.8774L86.5753 93.6557L85.3766 82.6917L46.7624 86.9135ZM48.1241 99.3685L49.0782 108.095C49.1682 108.919 49.9088 109.513 50.7324 109.423L87.8554 105.365L86.7383 95.1468L48.1241 99.3685ZM89.3465 105.202L108.536 103.104C109.359 103.014 109.954 102.273 109.864 101.449L108.91 92.7227L88.2294 94.9838L89.3465 105.202ZM108.747 91.2316L107.548 80.2677L86.8677 82.5287L88.0664 93.4927L108.747 91.2316ZM107.385 78.7766L106.187 67.8133L85.506 70.0744L86.7046 81.0376L107.385 78.7766ZM48.9881 65.7525C48.4391 65.8125 48.0427 66.3063 48.1027 66.8553C48.1627 67.4043 48.6564 67.8007 49.2054 67.7407L73.1185 65.1262C73.6675 65.0662 74.0639 64.5725 74.0038 64.0235C73.9438 63.4745 73.4501 63.0781 72.9011 63.1381L48.9881 65.7525ZM87.9588 62.4978C87.8988 61.9487 88.2952 61.455 88.8442 61.395L94.8225 60.7414C95.3715 60.6814 95.8652 61.0778 95.9252 61.6268C95.9852 62.1758 95.5888 62.6695 95.0398 62.7295L89.0616 63.3831C88.5126 63.4432 88.0188 63.0468 87.9588 62.4978ZM50.2953 77.7089C49.7463 77.7689 49.3499 78.2626 49.4099 78.8116C49.4699 79.3606 49.9636 79.757 50.5126 79.697L74.4257 77.0826C74.9747 77.0225 75.3711 76.5288 75.3111 75.9798C75.251 75.4308 74.7573 75.0344 74.2083 75.0944L50.2953 77.7089ZM89.266 74.4541C89.206 73.9051 89.6024 73.4114 90.1514 73.3513L96.1297 72.6977C96.6787 72.6377 97.1724 73.0341 97.2324 73.5831C97.2924 74.1321 96.896 74.6259 96.347 74.6859L90.3688 75.3395C89.8198 75.3995 89.326 75.0031 89.266 74.4541ZM51.7114 90.6617C51.1624 90.7217 50.766 91.2155 50.826 91.7645C50.8861 92.3135 51.3798 92.7099 51.9288 92.6499L75.8418 90.0354C76.3908 89.9754 76.7872 89.4817 76.7272 88.9327C76.6672 88.3836 76.1735 87.9872 75.6244 88.0473L51.7114 90.6617ZM90.6822 87.4069C90.6221 86.8579 91.0185 86.3642 91.5676 86.3042L97.5458 85.6506C98.0948 85.5905 98.5886 85.9869 98.6486 86.536C98.7086 87.085 98.3122 87.5787 97.7632 87.6387L91.7849 88.2923C91.2359 88.3524 90.7422 87.956 90.6822 87.4069ZM53.0187 102.618C52.4696 102.678 52.0732 103.172 52.1333 103.721C52.1933 104.27 52.687 104.666 53.236 104.606L77.149 101.992C77.6981 101.932 78.0945 101.438 78.0344 100.889C77.9744 100.34 77.4807 99.9438 76.9317 100.004L53.0187 102.618ZM91.9894 99.3635C91.9294 98.8145 92.3258 98.3208 92.8748 98.2608L98.853 97.6072C99.4021 97.5471 99.8958 97.9435 99.9558 98.4925C100.016 99.0416 99.6194 99.5353 99.0704 99.5953L93.0922 100.249C92.5431 100.309 92.0494 99.9125 91.9894 99.3635Z"
      fill="#C0DDFE"
    />
    <g filter="url(#filter1_d_10083_73648)">
      <path
        d="M138.128 87.7043L129.558 136.534C129.123 139.009 126.752 140.634 124.278 140.2L86.9067 133.641C84.4333 133.207 82.765 130.826 83.1915 128.396L91.7619 79.5663C92.1963 77.0911 94.5755 75.4211 97.049 75.8552L134.466 82.4224C136.894 82.8487 138.562 85.2291 138.128 87.7043Z"
        fill="url(#paint4_linear_10083_73648)"
      />
    </g>
    <path
      d="M138.128 87.7043L135.984 99.919C135.899 100.406 135.435 100.731 134.948 100.646L90.3448 92.8173C89.8579 92.7319 89.5325 92.2679 89.618 91.7811L91.7619 79.5663C92.1963 77.0911 94.5755 75.4211 97.049 75.8552L134.466 82.4224C136.894 82.8487 138.562 85.2291 138.128 87.7043Z"
      fill="#BFDDFE"
    />
    <path
      d="M98.1481 103.14L93.1562 102.264C92.4366 102.138 91.9547 101.45 92.0811 100.73L92.476 98.4797C92.6024 97.7596 93.2897 97.2772 94.0093 97.4035L99.0012 98.2796C99.7207 98.4059 100.203 99.0936 100.076 99.8136L99.6813 102.064C99.5549 102.784 98.8676 103.266 98.1481 103.14Z"
      fill="#7FBAFE"
    />
    <path
      d="M108.49 104.955L103.498 104.079C102.779 103.953 102.297 103.265 102.423 102.545L102.818 100.295C102.945 99.5748 103.632 99.0924 104.352 99.2187L109.343 100.095C110.063 100.221 110.545 100.909 110.419 101.629L110.024 103.879C109.897 104.599 109.21 105.082 108.49 104.955Z"
      fill="#7FBAFE"
    />
    <path
      d="M118.88 106.779L113.843 105.895C113.123 105.768 112.641 105.081 112.768 104.361L113.163 102.111C113.289 101.39 113.976 100.908 114.696 101.034L119.688 101.91C120.407 102.037 120.889 102.724 120.763 103.445L120.368 105.695C120.241 106.415 119.554 106.897 118.88 106.779Z"
      fill="#7FBAFE"
    />
    <path
      d="M129.223 108.594L124.231 107.718C123.511 107.592 123.029 106.904 123.156 106.184L123.551 103.934C123.677 103.214 124.364 102.731 125.084 102.858L130.076 103.734C130.795 103.86 131.277 104.548 131.151 105.268L130.756 107.518C130.585 108.23 129.942 108.72 129.223 108.594Z"
      fill="#7FBAFE"
    />
    <path
      d="M96.7184 111.286L91.7265 110.41C91.0069 110.284 90.525 109.596 90.6514 108.876L91.0463 106.626C91.1727 105.906 91.86 105.423 92.5796 105.549L97.5715 106.426C98.291 106.552 98.773 107.24 98.6466 107.96L98.2516 110.21C98.1253 110.93 97.4379 111.412 96.7184 111.286Z"
      fill="#7FBAFE"
    />
    <path
      d="M107.061 113.101L102.069 112.225C101.349 112.099 100.867 111.411 100.994 110.691L101.389 108.441C101.515 107.721 102.202 107.238 102.922 107.365L107.914 108.241C108.633 108.367 109.115 109.055 108.989 109.775L108.594 112.025C108.468 112.745 107.78 113.228 107.061 113.101Z"
      fill="#7FBAFE"
    />
    <path
      d="M117.45 114.925L112.413 114.041C111.693 113.914 111.212 113.227 111.338 112.507L111.733 110.257C111.859 109.536 112.547 109.054 113.266 109.18L118.258 110.056C118.978 110.183 119.459 110.87 119.333 111.591L118.938 113.841C118.812 114.561 118.124 115.043 117.45 114.925Z"
      fill="#7FBAFE"
    />
    <path
      d="M127.793 116.74L122.801 115.864C122.082 115.738 121.6 115.05 121.726 114.33L122.121 112.08C122.247 111.36 122.935 110.877 123.654 111.004L128.646 111.88C129.366 112.006 129.848 112.694 129.721 113.414L129.326 115.664C129.155 116.376 128.513 116.866 127.793 116.74Z"
      fill="#7FBAFE"
    />
    <path
      d="M95.2965 119.387L90.3046 118.511C89.5851 118.384 89.1031 117.697 89.2295 116.977L89.6244 114.727C89.7508 114.006 90.4382 113.524 91.1577 113.65L96.1496 114.526C96.8691 114.653 97.3511 115.34 97.2247 116.06L96.8298 118.311C96.6955 119.076 96.0161 119.513 95.2965 119.387Z"
      fill="#7FBAFE"
    />
    <path
      d="M105.639 121.202L100.647 120.326C99.9274 120.2 99.4454 119.512 99.5718 118.792L99.9667 116.542C100.093 115.822 100.78 115.339 101.5 115.465L106.492 116.342C107.211 116.468 107.693 117.156 107.567 117.876L107.172 120.126C107.038 120.891 106.358 121.328 105.639 121.202Z"
      fill="#7FBAFE"
    />
    <path
      d="M116.028 123.026L110.991 122.141C110.272 122.015 109.79 121.328 109.916 120.607L110.311 118.357C110.437 117.637 111.125 117.155 111.844 117.281L116.836 118.157C117.556 118.283 118.038 118.971 117.911 119.691L117.516 121.941C117.382 122.706 116.703 123.144 116.028 123.026Z"
      fill="#7FBAFE"
    />
    <path
      d="M128.247 121.552L126.422 131.948C126.296 132.668 125.608 133.15 124.934 133.032L119.942 132.156C119.222 132.029 118.74 131.342 118.867 130.622L120.691 120.226C120.818 119.505 121.505 119.023 122.225 119.149L127.216 120.025C127.936 120.152 128.373 120.832 128.247 121.552Z"
      fill="#7FBAFE"
    />
    <path
      d="M93.8668 127.533L88.8749 126.657C88.1554 126.53 87.6734 125.843 87.7998 125.122L88.1948 122.872C88.3211 122.152 89.0085 121.67 89.728 121.796L94.7199 122.672C95.4395 122.798 95.9214 123.486 95.795 124.206L95.4001 126.456C95.2658 127.222 94.5864 127.659 93.8668 127.533Z"
      fill="#7FBAFE"
    />
    <path
      d="M104.209 129.348L99.2172 128.472C98.4977 128.345 98.0157 127.658 98.1421 126.938L98.537 124.687C98.6634 123.967 99.3507 123.485 100.07 123.611L105.062 124.487C105.782 124.614 106.264 125.301 106.137 126.021L105.742 128.272C105.608 129.037 104.929 129.474 104.209 129.348Z"
      fill="#7FBAFE"
    />
    <path
      d="M114.598 131.171L109.561 130.287C108.842 130.161 108.36 129.473 108.486 128.753L108.881 126.503C109.008 125.783 109.695 125.3 110.415 125.427L115.406 126.303C116.126 126.429 116.608 127.117 116.482 127.837L116.087 130.087C115.952 130.852 115.273 131.29 114.598 131.171Z"
      fill="#7FBAFE"
    />
    <path
      d="M130.636 95.5282L96.2778 89.4978C95.1085 89.2926 94.285 88.1738 94.4983 86.9587L95.3909 81.8732C95.5962 80.7031 96.7144 79.8788 97.9287 80.0919L132.287 86.1223C133.457 86.3276 134.28 87.4463 134.067 88.6614L133.174 93.7469C132.924 94.9091 131.806 95.7335 130.636 95.5282Z"
      fill="white"
    />
    <path
      d="M116.578 89.2568L129.44 91.5142C130.07 91.6247 130.651 91.2165 130.762 90.5864C130.872 89.9564 130.465 89.3745 129.835 89.264L116.973 87.0065C116.343 86.896 115.762 87.3043 115.651 87.9343C115.586 88.5723 115.993 89.1541 116.578 89.2568Z"
      fill="#047CFF"
    />
    <defs>
      <filter
        id="filter0_d_10083_73648"
        x="6.11328"
        y="9.13818"
        width="141.687"
        height="160.713"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_73648"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_73648"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_73648"
        x="61.125"
        y="64.7866"
        width="99.0718"
        height="108.484"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_73648"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_73648"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_73648"
        x1="20.9981"
        y1="139.999"
        x2="140.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_73648"
        x1="70.5932"
        y1="19.2966"
        x2="83.1143"
        y2="133.821"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_73648"
        x1="49.5787"
        y1="122.183"
        x2="50.0403"
        y2="115.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_73648"
        x1="91.1206"
        y1="47.235"
        x2="115.558"
        y2="19.2895"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_73648"
        x1="115.954"
        y1="77.7956"
        x2="105.468"
        y2="137.541"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
